<template>
  <div class="text-center">
    <v-bottom-sheet v-model="sheet" inset>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="error"
          dark
          v-bind="attrs"
          v-on="on"
          class="rounded-pill pulse-animation"
          @click.stop
        >
          <v-icon left>mdi-phone</v-icon> Contacto
        </v-btn>
      </template>
      <v-sheet
        class="text-center rounded-lg"
        height="250px"
        style="left: 10px; top: 50%; transform: translateY(-50%)"
      >
        <v-btn class="mt-6 ml-2" color="error" @click="sheet = !sheet">
          Cerrar
        </v-btn>
        <div class="my-3">
          <v-icon color="primary">mdi-phone</v-icon>
          <v-icon color="green darken-4">mdi-whatsapp</v-icon>
          <a href="tel:+34617870811">617 870 811</a>
        </div>
        <div class="my-3">
          <v-icon color="primary">mdi-phone</v-icon>
          <v-icon color="green darken-4">mdi-whatsapp</v-icon>
          <a href="tel:+34692348434"> 692 348 434</a>
        </div>
        <div class="my-3">
          <v-icon color="blue">mdi-email</v-icon>
          <a :href="'mailto:reformashernanmora@gmail.com'"
            >reformashernanmora@gmail.com</a
          >
        </div>
        <div class="my-3">
          <a
            :href="'https://www.facebook.com/profile.php?id=61555855631904&locale=es_ES'"
            target="_blank"
          >
            <v-icon color="teal">mdi-facebook</v-icon>
          </a>
          <a
            :href="'https://www.instagram.com/hernanmorareformas/'"
            target="_blank"
          >
            <v-icon color="red">mdi-instagram</v-icon>
          </a>
          <span> Síguenos en redes sociales</span>
        </div>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>
  
  <script>
export default {
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    sheet: false,
  }),
};
</script>
  
  <style scoped>
.pulse-animation {
  animation: pulse 1s infinite;
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

.rounded-pill {
  border-radius: 50px;
}

.font-weight-bold {
  font-weight: bold;
  font-size: 1.2rem;
  color: #333; /* Puedes ajustar el color según tu preferencia */
}
.color-azul {
  color: #3b3bdd;
}
</style>
  